import { TableCell, TableRow } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { STATIC_STRINGS } from "@asez/shared";

const CandidateRow = ({ candidates, handleDelete }) => {
  return candidates.length > 0 ? (
    candidates.map((candidate, index) => (
      <TableRow
        key={candidate.email}
        sx={{
          borderBottom: index == candidates.length - 1 ? "none" : "",
        }}
      >
        <TableCell>
          <span className="text-sm xl:text-base">{candidate.name}</span>
        </TableCell>
        <TableCell align="center">
          <span className="text-sm xl:text-base">{candidate.email}</span>
        </TableCell>
        <TableCell align="center">
          <button
            className="cursor-not-allowed text-neutral-dark hover:text-neutral-dark/60  w-10 px-1"
            //TODO: enable when delete API available
            disabled
            onClick={() => {
              handleDelete(index);
            }}
          >
            <DeleteForeverIcon />
          </button>
        </TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={3} align="center">
        <span className="text-sm xl:text-base">
          {STATIC_STRINGS.NO_CANDIDATES}
        </span>
      </TableCell>
    </TableRow>
  );
};

export default CandidateRow;
